import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import styled from 'types/theme.types';
import Button from 'components/common/button';
import EmptyStateLayout from 'components/common/empty-state-layout';

/**
 * The catch-all used to redirect to `/` without saying anything, so a typo or a stale link looked like a
 * deliberate trip to the homepage. `forbidden.route` already reads "Page not found" for the 403; it keeps
 * its own copy rather than being reused here.
 */
const NotFoundPage: React.FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <CenteredEmptyState
      data-e2e="not-found"
      illustration="empty-state"
      titleId="not-found.title"
      description={<FormattedMessage id="not-found.description" />}
      action={
        <Button type="primary" data-e2e="not-found-go-home" onClick={() => navigate('/', { replace: true })}>
          <FormattedMessage id="not-found.go-home" />
        </Button>
      }
    />
  );
};

// Nothing above this page sets a height: it renders straight into MainLayout, without the InnerLayout
// every routed page gets. ErrorContainer centres itself for the same reason.
const CenteredEmptyState = styled(EmptyStateLayout)`
  height: 100%;
  justify-content: center;
`;

export default NotFoundPage;
